import React, { Component } from 'react';
import styled from 'styled-components';
import {i18n} from '../i18n';
import {Const} from '../stores/Constants';
import {store} from '../stores/mainStore';

const ToSBody = styled.div`
	width: 100vw;
	display: flex;
	flex-direction: column;
	background-color: white;
	height: calc(100vh - ${(p) => p.topHeight ? store.topBar.heightWide : '0vw'});
	margin-top: ${(p) => p.topHeight ? store.topBar.heightWide : '0vw'};
	@media (max-aspect-ratio: ${store.topBar.wtRatio}) {
		height: calc(100vh - ${(p) => p.topHeight ? store.topBar.heightTall : '0vw'});
		margin-top: ${(p) => p.topHeight ? store.topBar.heightTall : '0vw'};
	}
`;

const ToSButton = styled.button`${p => {
	const color = Const.BUTTON_SCHEME[store.isHardRock ? 'purple' : 'blue'];
	return`
		padding: 0;
		flex: 0 0 8vh;
		background-image: linear-gradient(to right, ${color.bottomGrad});
		box-shadow: inset 0 -1px 2px 0 ${color.topShadowColor};
		border-radius: 3vw;
		border: none;
		cursor: pointer;
		outline-offset: 4px;
		margin-top: 1vw;
		transform: translate3d(0,0,1px);

		& .top {
			display: block;
			padding: 3vw;
			border-radius: 3vw;
			text-align: center;
			font-weight: 800;
			font-size: 2rem;
			text-shadow: 0 0.1em 0 ${color.bottomShadowColor};
			background-image: linear-gradient(${color.topGrad});
			box-shadow: inset 0 0 1vw 0 ${color.topShadowColor};
			color: white;
			transform: translateY(-1vw);
			margin-bottom: 1vw;
		}
	`;
}}
	&:active .top {
		transform: translateY(0);
	  }
`;

const ScrollWrapper = styled.div`
	-webkit-overflow-scrolling: touch;
    overflow-y: scroll;
	overflow-x: hidden;
	flex-grow: 1;
	height: 100vh;
	width: 100vw;
`;

const ToSFrame = styled.iframe`
background-color: white;
	border: 0;
	height: 100vh;
	width: 100vw;
`;

export class IFrameWithCloseButton extends Component {
	render() {
		const {onClick, iframe, topBarHeight, className} = this.props;
        return (
            <ToSBody topHeight={topBarHeight} className = {className}>
                <ToSButton opacity={1} onClick={onClick}>
                    <span className='top'>{i18n.t('close')}</span>
                </ToSButton>
				<ScrollWrapper>
                	<ToSFrame title="terms" src={iframe} sandbox={"allow-scripts allow-same-origin"} />
				</ScrollWrapper>
            </ToSBody>
		);
	}
}
